import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "tw"
};
const _hoisted_2 = {
  class: "py-1 text-sm"
};
const _hoisted_3 = {
  class: ""
};
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSelect from '@/components/LlSelect.vue';
import { reactive, computed, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
export default {
  __name: 'MatterInvolvingFilter',
  props: {
    horizontal: {
      type: Boolean,
      required: false,
      default: false
    },
    form: {
      type: Object,
      required: false
    },
    lockAccountSelection: {
      type: Boolean,
      required: false,
      default: false
    },
    simplifiedMode: {
      type: Boolean,
      required: false,
      default: false
    },
    // Overrides the firm-wide list, e.g. reports narrow it by role.
    accounts: {
      type: Array,
      required: false,
      default: null
    }
  },
  emits: ['matterInvolvingChange'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;

    // Store refs
    const meStore = useMeStore();
    const {
      me,
      features
    } = storeToRefs(meStore);
    const accountsStore = useAccountsStore();
    const {
      accountsList
    } = storeToRefs(accountsStore);
    const accounts = computed(() => props.accounts || accountsList.value || []);

    // Load store data on mount
    onMounted(async () => {
      try {
        // Load me data if not already loaded
        if (!me.value || !me.value.id) {
          await meStore.getMe();
        }

        // Load accounts list if not already loaded
        if (!props.accounts && !accountsList.value?.length) {
          await accountsStore.listAccounts();
        }
      } catch (error) {
        // Silently fail - in tests or when stores aren't available, this is expected
      }
    });
    const localState = reactive({
      localForm: props.form
    });

    // Watch for prop changes and update local state
    watch(() => props.form, newForm => {
      if (newForm) {
        localState.localForm = newForm;
      }
    }, {
      deep: true,
      immediate: true
    });
    const scopeChange = prop => {
      if (!props.form.scopeAccount) {
        localState.localForm.scope = 'all';
        localState.localForm.primary = false;
        localState.localForm.originating = false;
        localState.localForm.reviewer = false;
        emit('matterInvolvingChange', localState.localForm);
        return;
      }

      // In simplified mode, always set primary to true and others to false
      if (props.simplifiedMode) {
        localState.localForm.primary = true;
        localState.localForm.originating = false;
        localState.localForm.reviewer = false;
        localState.localForm.scope = 'primary';
        emit('matterInvolvingChange', localState.localForm);
        return;
      }
      const {
        primary,
        reviewer,
        originating
      } = localState.localForm;
      const scopes = [];
      if (primary) scopes.push('primary');
      if (reviewer) scopes.push('reviewer');
      if (originating) scopes.push('originating');
      localState.localForm.scope = scopes.length ? scopes.join(',') : 'involved';
      emit('matterInvolvingChange', localState.localForm);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("label", _hoisted_2, _toDisplayString(__props.simplifiedMode ? 'Responsible Attorney' : `Show ${_unref(me)?.terms?.Matter}s Involving`), 1), _createElementVNode("div", _hoisted_3, [_createVNode(LlSelect, {
        modelValue: __props.form.scopeAccount,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => __props.form.scopeAccount = $event), _cache[1] || (_cache[1] = $event => scopeChange())],
        items: accounts.value,
        placeholder: __props.simplifiedMode ? 'Select Attorney' : 'Filter by Matter',
        labelClass: "remove-outline",
        "item-title": "name",
        "item-value": "id",
        clearable: "",
        searchable: "",
        isAutocomplete: true,
        "hide-details": true,
        disabled: __props.lockAccountSelection
      }, null, 8, ["modelValue", "items", "placeholder", "disabled"])]), _createElementVNode("div", {
        class: _normalizeClass([__props.horizontal ? 'flex-col' : 'flex-row', "flex justify-start py-2"])
      }, [_withDirectives(_createVNode(LlCheckbox, {
        modelValue: __props.form.primary,
        "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => __props.form.primary = $event), _cache[3] || (_cache[3] = $event => scopeChange('primary'))],
        label: "Responsible",
        disabled: __props.simplifiedMode,
        info: `Include matters where ${__props.form.scopeAccount?.id === _unref(me)?.id ? 'you are' : 'this user is'} the responsible`
      }, null, 8, ["modelValue", "disabled", "info"]), [[_vShow, __props.form.scopeAccount]]), !__props.simplifiedMode ? _withDirectives((_openBlock(), _createBlock(LlCheckbox, {
        key: 0,
        modelValue: __props.form.originating,
        "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => __props.form.originating = $event), _cache[5] || (_cache[5] = $event => scopeChange('originating'))],
        label: "Originating",
        info: `Include matters where ${__props.form.scopeAccount?.id === _unref(me)?.id ? 'you are' : 'this user is'} the originating`
      }, null, 8, ["modelValue", "info"])), [[_vShow, __props.form.scopeAccount]]) : _createCommentVNode("", true), !__props.simplifiedMode ? _withDirectives((_openBlock(), _createBlock(LlCheckbox, {
        key: 1,
        modelValue: __props.form.reviewer,
        "onUpdate:modelValue": [_cache[6] || (_cache[6] = $event => __props.form.reviewer = $event), _cache[7] || (_cache[7] = $event => scopeChange('reviewer'))],
        label: "Reviewer",
        info: `Include matters where ${__props.form.scopeAccount?.id === _unref(me)?.id ? 'you are' : 'this user is'} the reviewer`
      }, null, 8, ["modelValue", "info"])), [[_vShow, __props.form.scopeAccount && _unref(me)?.company?.settings?.workflow?.reviewer]]) : _createCommentVNode("", true)], 2)]);
    };
  }
};